// src/components/admin/blockEditors/ContentStructureBlockEditor.tsx - CRIAR

import React, { useState, useEffect } from 'react';
import { Trash2 } from 'lucide-react';
import { ContentStructureBlock } from '../../../types/contentBlocks.types';
import './BlockEditors.css';

interface ContentStructureBlockEditorProps {
    block: ContentStructureBlock;
    onChange: (block: ContentStructureBlock) => void;
}

interface Deck {
    _id: string;
    name: string;
}

export const ContentStructureBlockEditor: React.FC<ContentStructureBlockEditorProps> = ({ block, onChange }) => {
    const [deckIds, setDeckIds] = useState<string[]>(block.data.deckIds);
    const [availableDecks, setAvailableDecks] = useState<Deck[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadDecks();
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            onChange({
                ...block,
                data: { deckIds }
            });
        }, 500);

        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deckIds]);

    const loadDecks = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('accessToken');

            const response = await fetch(
                '/api/admin/marketplace/decks/all',
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.ok) {
                const data = await response.json();
                setAvailableDecks(data.decks || []);
            }
        } catch (error) {
            console.error('Erro ao carregar decks:', error);
        } finally {
            setLoading(false);
        }
    };

    const addDeck = (deckId: string) => {
        if (!deckIds.includes(deckId)) {
            setDeckIds([...deckIds, deckId]);
        }
    };

    const removeDeck = (deckId: string) => {
        setDeckIds(deckIds.filter(id => id !== deckId));
    };

    const selectedDecks = availableDecks.filter(d => deckIds.includes(d._id));
    const unselectedDecks = availableDecks.filter(d => !deckIds.includes(d._id));

    return (
        <div className="be-container">
            <div className="be-form-group">
                <label className="be-label">Decks Selecionados ({deckIds.length})</label>
                {deckIds.length === 0 ? (
                    <div className="be-info-box">
                        ℹ️ Nenhum deck selecionado. Adicione decks abaixo.
                    </div>
                ) : (
                    <div className="be-selected-cards">
                        {selectedDecks.map(deck => (
                            <div key={deck._id} className="be-selected-card">
                                <span className="be-card-preview">{deck.name}</span>
                                <button
                                    className="be-btn-remove-card"
                                    onClick={() => removeDeck(deck._id)}
                                    title="Remover"
                                >
                                    <Trash2 size={16} />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className="be-form-group">
                <label className="be-label">Adicionar Decks</label>
                {loading ? (
                    <p className="be-loading-text">Carregando decks...</p>
                ) : unselectedDecks.length === 0 ? (
                    <div className="be-info-box">
                        ✅ Todos os decks foram adicionados
                    </div>
                ) : (
                    <div className="be-cards-grid">
                        {unselectedDecks.map(deck => (
                            <div
                                key={deck._id}
                                className="be-card-option"
                                onClick={() => addDeck(deck._id)}
                            >
                                <div className="be-card-front">
                                    {deck.name}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};